<script>
import {mapActions, mapState} from "vuex";
import InteractionStatementStore from "../../../../../stores/application/hostel/interactionStatement_store";
import _ from "lodash";

export default {
  name: "CardDetailsStatement",
  props: {
    select_stm_hostel_id: Number,
    department_id: String
  },
  data: () => ({
    select_place: {
      name_hostel: '',
      name_section: '',
      room_id: ''
    }
  }),
  computed: {
    ...mapState({
      details_data_stm_hostel: state => state.interactionStatement.details_data_stm_hostel,
      distribution_places: state => state.placesInDormitories.distribution_places,
      places_for_select: state => state.placesInDormitories.places_for_select,
    }),
    placesHostels() {
      let ms_hostel = []

      this.places_for_select?.places?.forEach((places) => {
        ms_hostel.push(places.name_hostel)
      })

      return ms_hostel
    },
    setTypeStatement(){
      let type_statement = this.details_data_stm_hostel?.statement_type

      if (type_statement === 'Заселение'){
        return { name: type_statement, color: 'green' }
      }
      if (type_statement === 'Переселение'){
        return { name: type_statement, color: 'orange' }
      }
      if (type_statement === 'Выселение'){
        return { name: type_statement, color: 'red' }
      }

      return { name: 'Заселение', color: 'green' }
    }
  },
  methods: {
    ...mapActions({
      CreateRecordDistributionPersonDepartment: 'interactionStatement/CreateRecordDistributionPersonDepartment',
      GetStatementsForDepartment: 'interactionStatement/GetStatementsForDepartment',
      GetObjectPlacesDormFac: 'placesInDormitories/GetObjectPlacesDormFac',
    }),
    transitionListPlaces() {
      this.$emit('transitionListPlaces')
    },
    transitionListStatements() {
      this.$emit('transitionListStatements')
    },
    placeSections(name_hostel) {
      let curr_sections = []

      if (name_hostel) {
        let hostel = _.find(this.places_for_select?.places, (place) => {
          return place.name_hostel === name_hostel
        })

        hostel.sections.forEach((section) => {
          curr_sections.push(section)
        })
      }

      return curr_sections
    },
    placeRooms(name_hostel, name_section) {
      let curr_sections = this.placeSections(name_hostel)
      let curr_rooms = []

      if (name_hostel && name_section) {
        let section = _.find(curr_sections, (place) => {
          return place.name_section === name_section
        })

        section.rooms.forEach((room) => {
          curr_rooms.push({name_room: room.name_room, room_id: room.room_id})
        })
      }

      return curr_rooms
    },
    async checkingInPlace(){
      await this.CreateRecordDistributionPersonDepartment({
        room_id: this.select_place.room_id,
        statement_hostel_id: this.select_stm_hostel_id
      })
      await this.GetStatementsForDepartment(this.department_id)
      await this.GetObjectPlacesDormFac(this.department_id)

      this.transitionListStatements()
      this.transitionListPlaces()
    },

  }
}
</script>

<template>
  <v-card outlined class="rounded-xl" width="100%" height="100%">
    <v-card-title>
      <v-btn
          rounded
          small
          @click="transitionListStatements()"
          text
          color="teal"
          absolute
      >
        <v-icon left>
          fa fa-chevron-left
        </v-icon>
        Назад
      </v-btn>
      <h6
          class="mx-auto text-caption text-uppercase text--secondary"
      >
        Детали заявления
      </h6>
    </v-card-title>
    <div class="text-center text-subtitle-1">
      {{ details_data_stm_hostel.full_name }}
    </div>

    <v-divider/>

    <template v-if="setTypeStatement.name === 'Переселение'">
      <div class="text-center my-2">
        <div class="text-uppercase text--secondary text-subtitle-2">Текущее место проживания</div>
        <div class="my-2 d-flex justify-center">
          <v-icon left size="15px" color="green" v-if="details_data_stm_hostel.current_place_residence !== 'Ранее не заселен'">
            fa-check-circle
          </v-icon>
          <h6 class="text--primary text-subtitle-1">{{ details_data_stm_hostel.current_place_residence }}</h6>
        </div>
      </div>

      <v-divider class="my-2"/>
    </template>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <div class="text-uppercase">Тип заявления</div>
          <div style="height: calc(100% - 20px)" class="d-flex align-center">
            <v-chip
                class="rounded-xl"
                outlined
                :color="setTypeStatement.color"
            >
              {{ setTypeStatement.name }}
            </v-chip>
          </div>
        </v-col>
        <v-col cols="12" md="8">
          <div class="text-uppercase">Предложенные места</div>
          <div style="height: calc(100% - 20px)" class="d-flex align-center">
            <v-list
                width="100%"
                nav
                disabled
                rounded
                flat
            >
              <v-list-item v-for="(place, index) in details_data_stm_hostel.place_hostel" :key="index">
                <v-list-item-avatar>
                  <v-icon>
                    fa-bed
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-title>{{ place.name_hostel + " " + place.name_room }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div class="text-uppercase">Отличительный признак</div>
          <h6 class="text--primary text-subtitle-1">{{ details_data_stm_hostel.privilege }}</h6>
        </v-col>
        <v-col cols="12" md="6">
          <div class="text-uppercase">Группа</div>
          <h6 class="text--primary text-subtitle-1">{{ '3106-ом1' }}</h6>
        </v-col>
        <v-col cols="12" md="6">
          <div class="text-uppercase">РАУ</div>
          <h6 class="text--primary text-subtitle-1">{{ '5' }}</h6>
        </v-col>
        <v-col cols="12" md="6">
          <div class="text-uppercase">Факультет</div>
          <h6 class="text--primary text-subtitle-1">{{ 'ИКиИН' }}</h6>
        </v-col>
        <v-col cols="12" md="6">
          <div class="text-uppercase">Номер телефона</div>
          <h6 class="text--primary text-subtitle-1">{{ details_data_stm_hostel.curr_phone }}</h6>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider/>
    <v-card-text>
      <div v-if="setTypeStatement.name === 'Заселение'" class="text-uppercase text-center">Заселение</div>
      <div v-if="setTypeStatement.name === 'Переселение'" class="text-uppercase text-center">Переселение</div>
      <v-row class="ma-5" justify="center">
        <v-col cols="12" class="pb-0">
          <v-select
              label="Общежитие"
              v-model="select_place.name_hostel"
              :items="placesHostels"
              item-text="name_hostel"
              :rules="[v => !!v || 'Обязательное поле не заполнено']"
              no-data-text="Данные отсутствуют"
              hide-details
              rounded
              outlined
              required
          ></v-select>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-select
              label="Секция"
              v-model="select_place.name_section"
              :items="placeSections(select_place.name_hostel)"
              item-text="name_section"
              item-value="name_section"
              :rules="[v => !!v || 'Обязательное поле не заполнено']"
              no-data-text="Данные отсутствуют"
              hide-details
              rounded
              outlined
              required
          ></v-select>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-select
              label="Комната"
              v-model="select_place.room_id"
              :items="placeRooms(select_place.name_hostel, select_place.name_section)"
              item-text="name_room"
              item-value="room_id"
              :rules="[v => !!v || 'Обязательное поле не заполнено']"
              no-data-text="Данные отсутствуют"
              hide-details
              rounded
              outlined
              required
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn
          color="red"
          rounded
          outlined
          elevation="0"
      >
        Отклонить
      </v-btn>
      <v-spacer/>
      <v-btn
          @click="checkingInPlace()"
          color="teal"
          rounded
          dark
          elevation="0"
      >
        <template v-if="setTypeStatement.name === 'Переселение'">
          Переселить
        </template>
        <template v-else>
          Разместить
        </template>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>

</style>